import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/news', { params })
  },
  store (formData) {
    return apiClient.post('/news', formData)
  },
  show (id, params) {
    return apiClient.get(`/news/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/news/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/news/${id}`)
  }
}
